<template>
	<v-layout row wrap class="blue-grey lighten-5 pa-3">
		<v-flex xs12>
			<v-layout row wrap>
				<v-flex xs12 md12>
					<ValidationProvider
						name="time"
						rules=""
						v-slot="{ errors }"
					>
						<v-autocomplete
							:label="
								$t('label.search_customer_by_name_phone_email')
							"
							v-model="item.customer_id"
							:items="customers_data"
							item-value="id"
							item-text="full_display_name"
							data-vv-name="customer_id"
							:readonly="item.readonly"
							:error-messages="errors"
							append-icon="mdi-magnify"
							tile
							filled
							:loading="$wait.is('search')"
							loader-height="5"
							clearable
							hide-details
						>
						</v-autocomplete>
					</ValidationProvider>
				</v-flex>
			</v-layout>
		</v-flex>
	</v-layout>
</template>

<script>
import debounce from "lodash.debounce";
export default {
	props: ["value", "customers"],

	data() {
		return {
			search: "",
			customers_data: this.customers,
		};
	},

	computed: {
		item: {
			get() {
				return this.value;
			},
			set(value) {
				this.$emit("input", value);
			},
		},
	},

	methods: {
		chooseCustomer(customer) {
			this.item.customer_id = customer.id;
			this.item.customer = customer;
		},
	},

	watch: {
		search(...args) {
			this.debouncedWatch(...args);
		},
	},

	created() {
		this.debouncedWatch = debounce((newValue, oldValue) => {
			this.$wait.start("search");
			axios
				.get(
					this.$route("central.reservation.search.customer", {
						search: newValue,
					})
				)
				.then((response) => {
					if (response.status == 200) {
						this.customers_data = response.data.data;
					}
				})
				.finally(() => {
					this.$wait.end("search");
				});
		}, 500);
	},
	beforeUnmount() {
		this.debouncedWatch.cancel();
	},
};
</script>